/**
 * The HQ Site schema (`GET /schema`, contract §5): the sections and fields the landing
 * page declares editable, the anchors a link may target, the footer groups, the length
 * and size limits, and the accepted media types. Every other tab reads its rules from here
 * rather than restating them.
 *
 * @param {{ api?: typeof siteApi, enabled?: boolean }} [options] `enabled: false` defers
 *   the read (the media picker loads it only once opened).
 * @returns {{ status: "idle" | "loading" | "ready" | "error", schema: object | null, error: unknown,
 *             reload: () => Promise<void> }}
 */
import { useCallback, useEffect, useState } from "react";
import siteApi from "./siteApi";

export default function useSiteSchema({ api = siteApi, enabled = true } = {}) {
  const [status, setStatus] = useState(enabled ? "loading" : "idle");
  const [schema, setSchema] = useState(null);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setStatus("loading");
    try {
      setSchema(await api.getSchema());
      setError(null);
      setStatus("ready");
    } catch (e) {
      setError(e);
      setStatus("error");
    }
  }, [api]);

  useEffect(() => { if (enabled) reload(); }, [enabled, reload]);

  return { status, schema, error, reload };
}
